<template>
	<div>
		<v-alert class="mx-5 mt-1" type="error" v-if="errormsg.length !== 0">
			{{ errormsg }}
		</v-alert>
		<div class="results px-5 my-3">
			<SearchAdvance
				v-if="advancedFilter_visible" 
				:class="$vuetify.breakpoint.smAndDown ?'search-result-single' : 'search-filter' " 
				:statusses="statusses"
				:job_types="job_types"
				:panel="[0, 1, 2, 3]"
				@update-search="onUpdateSearch"
			/>
			<SearchColsFilter
				v-if="colsFilter_visible"  
				:class="$vuetify.breakpoint.smAndDown ?'search-result-single' : 'search-filter' " 
				:selected="selected"
				:financialsPrivilege="financialsPrivilege"
				@close="onCloseSearchColsFilter"/>
			<ProgressLinear v-if="loading"/>
			<div v-if="!loading && errormsg.length === 0 && search_results_visible" 
				:class="`results-table ${$vuetify.breakpoint.smAndDown ? 'search-result-single' : 'search-result-multi'}`">
				<div 
					v-if="save_as && $vuetify.breakpoint.smAndDown"
					class="mx-1 back" 
					@click="onBackToSearchOptions()">
					&lt; Back to Search options
				</div>
				<div v-if="save_as" :class="`${$vuetify.breakpoint.smAndDown ? 'save-as-sm my-3 mx-1':'save-as ma-3'}`">
					You have unsaved changes.
					<div class="save-as-bnt" @click="onShowSaveDialog()">Save as Worklist</div>
				</div>
				<SearchResults 
					:headers="head_kv" 
					:joblists="joblists"
					:color="$attrs.color" 
					:page="page"
					:perpage="limit"
					@columns="onColumns()"
					@pagination="onPagination($event)"/>
			</div>
		</div>
		<NewWorklistDialog 
			:visible="saveDialog_visible" 
			:is_saved="is_saved"
			@saved="onSaveAsWorklist"
			@cancel="saveDialog_visible = false"/>
	</div>
</template>
<script>
import SearchResults from "@/components/jobs/search_results_new";
import NewWorklistDialog from "@/components/worklist/new_worklist_dialog_new";
import SearchAdvance from '@/components/jobs/search_advance.vue';
import SearchColsFilter from '@/components/jobs/search_cols_filter';
import ProgressLinear from "@/components/progress/progress_getdata_linear";

import Worklist from "@/models/worklist.js";
import config from "@/config.js";
import { metaMixin } from "@/mixins/jobs/metaMixin";

const WORKLIST_CLASS = 'restful.jobs.worklists';
const wl = new Worklist();

/** If selected the user will be able to access the Financial tab in the Jobs window */
const JOf = 'JOf';
const Financials_Group = ['total_value', 'perc_quoted_billed', 'total_invoiced', 'perc_value_billed', 'perc_traffic_used'];

export default {
	name: 'SearchJobs',
	mixins: [ metaMixin ],
	components: {
		SearchResults,
		NewWorklistDialog,
		SearchAdvance,
		SearchColsFilter,
		ProgressLinear
	},
	data() {
		return {
			loading: false,
			errormsg: '',
			save_as: false,
			is_saved: false,
			advancedFilter_visible: true,
			colsFilter_visible: false,
			search_results_visible: !this.$vuetify.breakpoint.smAndDown,
			saveDialog_visible: false,

			financialsPrivilege: true,
			head_kv: [],
			search_param: null,	
			settings: null,
			joblists: [],
			search_status: [],
			page: 1,
			start: 0,
			limit: this.$vuetify.breakpoint.smAndDown ? 10 : config.countPerpage,
			tid: null,
			tid0: null,
		}
	},
	async created() {
		/* add this page to our breadcrumbs */
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: "Search jobs",
			to: this.$route.path
		});

		await this.load_meta_data();
		await this.getFinancialsPrivilege();

		if (this.financialsPrivilege) {
			this.head_kv = config.head_kv;
		} else {
			const head_tmp = JSON.parse(JSON.stringify(config.head_kv));
			head_tmp.forEach(h => {
				if (Financials_Group.includes(h.value)) {
					h.showable = false;
				}
			});
			this.head_kv = head_tmp;
		}
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
		if(this.tid0) {
			clearTimeout(this.tid0);
		}
	},
	computed: {
		selected() {
			const arr = [];
			this.head_kv.forEach(item => {
				if (item.showable) {
					const obj = {
						text: item.text,
						value: item.value,
					}
					arr.push(obj);
				}
			});
			return arr;
		},
	},
	methods: {
		async getFinancialsPrivilege() {
			const url = "/api/user/me/privileges";
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}					
				})
				.then(val => {
					const {status, data}  = val.data;

					if (status === "OK") {
						if (data.includes(JOf)) {
							this.financialsPrivilege = true;
						} else {
							this.financialsPrivilege = false;
						}
					}
				})
				.catch((e) => {
					this.errormsg = e.message;
				});
		},
		async onSearch(searchParams, params_obj) {
			if (!searchParams) return;

			const params = [];
			for (const [key, value] of Object.entries(searchParams)) {
				if (value) {
					params.push(key + '=' + encodeURIComponent(value));
				}
			}

			this.limit = params_obj ? params_obj.limit : (this.$vuetify.breakpoint.smAndDown ? 10 : config.countPerpage);
			this.page = params_obj ? params_obj.page : 1;
			this.start = params_obj ? params_obj.start : 0;

			params.push('limit' + '=' + encodeURIComponent(this.limit));
			params.push('start' + '=' + encodeURIComponent(this.start));
			params.push('is_lookup' + '=' + encodeURIComponent(false));

			this.loading = true;
			
			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const json = val.data;

					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data,  reason} = json;

					if (status === "OK") {
						this.save_as = true;
						this.joblists = data;
						this.loading = false;
					} else {
						this.errormsg = reason;
					}
				})
				.catch(e => {
					this.errormsg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});	
		},
		onUpdateSearch(event) {
			this.settings = event;
			this.onSearch(event);

			if (this.$vuetify.breakpoint.smAndDown) {
				this.advancedFilter_visible = false;
				this.colsFilter_visible = false;
				this.search_results_visible = true;
			}
		},
		onShowSaveDialog() {
			this.saveDialog_visible = true;
		},
		onSaveAsWorklist(params) {
			const search = {};
			for (const [key, value] of Object.entries(this.settings)) {
				search[`${key}`] = value ? value : null;
			}

			wl.id = 0;
			wl.class = WORKLIST_CLASS;
			wl.name = params.name;
			wl.is_dynamic = params.is_dynamic;
			wl.is_owned = true;
			wl.settings = search;
			
			wl.create()
				.then(() => {
					this.is_saved = true;
					this.tid = setTimeout(this._close, 2000);
					this.tid0 = setTimeout(this._setInit, 2500);
				})
				.catch(function(reason) {
					this.errormsg = reason;
					this._close();
				});
		},
		onColumns() {
			if (this.$vuetify.breakpoint.smAndDown) {
				this.advancedFilter_visible = false;
				this.colsFilter_visible = true;
				this.search_results_visible = false;
			} else {
				this.colsFilter_visible = !this.colsFilter_visible;
				if (this.colsFilter_visible) {
					this.advancedFilter_visible = false;
				} else {
					this.advancedFilter_visible = true;
				}
			}
		},
		onPagination(pagination) {
			const limit_res = pagination.limit;
			
			const start_tmp = (pagination.page - 1) * pagination.limit;
			const page_tmp = Math.ceil(pagination.total / pagination.limit);
			const page_res = start_tmp > pagination.total ? page_tmp : pagination.page;
			const start_res = start_tmp > pagination.total ? (page_res - 1) * pagination.limit : start_tmp;

			const obj = {
				page: page_res,
				limit: limit_res,
				start: start_res
			}
			this.onSearch(this.settings, obj);
		},
		onCloseSearchColsFilter(event) {
			if (event) {
				const event_arr = event.map(items => { return items.text});
				const obj = JSON.parse(JSON.stringify(config.head_kv));

				obj.forEach(head => {
					if (event_arr.includes(head['text'])) {
						head['showable'] = true;
					} else {
						head['showable'] = false;
					}
				})
				this.head_kv = obj;
			}
			if (this.$vuetify.breakpoint.smAndDown) {
				this.advancedFilter_visible = false;
				this.colsFilter_visible = false;
				this.search_results_visible = true;
			} else {
				this.advancedFilter_visible = true;
				this.colsFilter_visible = false;
				this.search_results_visible = true;
			}
		},
		onBackToSearchOptions() {
			if (this.$vuetify.breakpoint.smAndDown) {
				this.advancedFilter_visible = true;
				this.colsFilter_visible = false;
				this.search_results_visible = false;
			} 
		},
		_close() {
			this.saveDialog_visible = false;
			this.$router.push({ name: "Saved Job Worklists" })
		},
		_setInit() {
			this.is_saved = false;
		}
	}
}
</script>
<style lang="scss" scoped>
.search-filter {
	width: 24%;
}
.search-result-single {
	width: 100%;
}
.search-result-multi {
	width: 75%;
}
.results {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
}
.results-table {
	display: flex;
	flex-flow: column nowrap;
	align-items: space-between;
}
.save-as {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: #00AAFD;
}
.save-as-sm {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: #00AAFD;
}
.save-as-bnt {
	background: #00AAFD;
	border-radius: 4px;
	color: #FFFFFF;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	text-align: center;
	margin-left: 20px;
	padding: 6px 12px;
	&:hover {
		cursor: pointer;
	}
}
.back {
	color: #2196F3;
	text-decoration: underline;
	font-family: Roboto;
	font-style: normal;
	font-weight: bold;
	font-size: 16px;
	line-height: 24px;
	&:hover {
		cursor: pointer;
	}
}
</style>